import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
//import { Navigation } from "./Navigation";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import "./Component/Asset.css";
import { Grid } from "@mui/material";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { Button } from "@mui/material";
import { TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useParams } from "react-router";
import { API_DOMAIN_URL } from "./Common";

export function ResetPassword() {
  const [formStatus, setFormStatus] = useState(0);
  const [userName, setUserName] = useState("");
  let params = useParams();

  useEffect(() => {
    let token = params.Token;

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/ValidateResetPasswordToken?code=${code}&Token=${token}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        setUserName(response.UserName);
      })
      .catch(() => {
        console.error();
      });
  }, []);

  const validationSchema = Yup.object().shape({
    Password: Yup.string()
      .required("パスワードを入力してください")
      .min(8, "8文字以上のパスワードを入力してください"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  // フォームに入力されたデータをチェックして
  // 確認画面へ遷移
  const onSubmit = (data) => {
    if (data.Password == undefined) {
      console.log("Invalid Input Value");
      return;
    }

    // トークン発行とメール送信
    sendData(data.Password);
  };

  const sendData = (password) => {
    if (!password) {
      return;
    }

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/UpdatePassword?code=${code}&UserName=${userName}&Password=${password}&Token=${params.Token}`;
    //console.log(url);
    fetch(url, {
      method: "POST",
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          setFormStatus(1);
        } else if (
          response.status == 204 ||
          response.status == 400 ||
          response.status == 500
        ) {
          errorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  const inputFrom = (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        marginTop: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography component="h1" variant="h5">
        新しいパスワードの設定
      </Typography>

      <Grid
        container
        direction="columun"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          item
          md={12}
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          sx={{ p: "10px" }}
        >
          <Grid item md={12}>
            <Typography variant="body">{userName}様</Typography>
          </Grid>
          <Grid item md={12} mt={1}>
            <Typography variant="body2">新しいパスワードを入力</Typography>
          </Grid>
          <Grid item md={12} mt={1}>
            <TextField
              required
              size="small"
              fullWidth
              name="Password"
              label="新しいパスワード"
              type="password"
              id="Password"
              {...register("Password")}
              error={errors.Password ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.Password?.message}
            </Typography>
          </Grid>
          <Grid item md={10}></Grid>
          <Grid item md={2}>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2, pl: "20px", pr: "20px", pt: "10px", pb: "10px" }}
              align
              type="submit"
            >
              更新
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );

  const passwordChanged = (
    <Box
      noValidate
      sx={{
        marginTop: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography component="h1" variant="h5">
        更新完了
      </Typography>

      <Grid
        container
        direction="columun"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          item
          md={12}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ p: "10px" }}
        >
          <Grid item md={12} alignItems="center">
            <Typography variant="body2" textAlign="center">
              パスワードを更新しました。
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );

  // エラーモーダル
  const [open, setOpen] = React.useState(false);
  const errorModalOpen = () => {
    setOpen(true);
  };
  const errorModalClose = () => {
    setOpen(false);
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        {formStatus == 0 ? inputFrom : passwordChanged}
      </Container>
      <Dialog
        open={open}
        onClose={errorModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">更新エラー</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            パスワードの更新に失敗しました。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={errorModalClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
